import get from "lodash/get";
import {
    getInvoiceClientListDteLoading,
    getInvoiceClientListDteReject,
    getInvoiceClientListDteRequest,
    getInvoiceClientListDteSuccess,
} from "../../actions/invoiceClient/getListDTE";

export const getInvoiceClientListDTE = (params) => async (dispatch, getState) => {
    dispatch(getInvoiceClientListDteLoading());
    try {
        const { data } = await getInvoiceClientListDteRequest(params, getState);
        dispatch(getInvoiceClientListDteSuccess(data));
    } catch (error) {
        dispatch(getInvoiceClientListDteReject(get(error, "response.data", error)));
    }
    return Promise.resolve();
};
